"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBInfoPositive = function SvgBInfoPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M5.882 143.238a5.89 5.89 0 01-5.562-7.787l10.065-29.714A70.857 70.857 0 0146.743 5.623a2.295 2.295 0 011.653 4.282 66.286 66.286 0 00-33.813 93.988c.43.466.649 1.09.602 1.722v.107c-.022.312-.11.616-.26.891L4.649 136.914a1.31 1.31 0 001.668 1.669l18.59-6.301a2.286 2.286 0 011.471 4.328l-18.59 6.308a5.905 5.905 0 01-1.905.32z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M62.232 140.952a2.08 2.08 0 01-.312 0 70.156 70.156 0 01-41.821-21.897 2.286 2.286 0 113.352-3.108 65.562 65.562 0 0039.086 20.434 2.29 2.29 0 01-.305 4.571z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M65.935 141.326h-.183a68.891 68.891 0 01-28.998-9.044 2.287 2.287 0 012.286-3.962A64.541 64.541 0 0060.137 136a13.79 13.79 0 01-1.691-6.636V46.735a13.905 13.905 0 1127.802 0v82.621a13.935 13.935 0 01-5.905 11.36 2.286 2.286 0 11-2.636-3.733 9.356 9.356 0 003.97-7.62V46.736a9.333 9.333 0 00-18.66 0v82.621a9.326 9.326 0 004.183 7.787 2.286 2.286 0 01-1.265 4.19v-.007z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M95.924 137.646a2.286 2.286 0 01-.762-4.435 66.034 66.034 0 0010.667-119.367l-.122-.069a64.693 64.693 0 00-21.09-7.68 13.905 13.905 0 01-8.38 20c-1.252.373-2.55.566-3.856.572a13.89 13.89 0 01-7.97-25.296 2.286 2.286 0 112.637 3.734 9.326 9.326 0 1010.506-.153 2.286 2.286 0 011.44-4.19 69.006 69.006 0 0128.953 8.998l.122.069c23.86 13.717 37.577 40.048 35.143 67.463-2.434 27.416-20.576 50.918-46.48 60.217a2.29 2.29 0 01-.808.137z",
    fill: "#1B7"
  })));
};

var _default = SvgBInfoPositive;
exports["default"] = _default;